var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral-start.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0c30b644!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral-start.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MoralStart.vue
// module id = 1333
// module chunks = 1